import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ComparisonModal from './ComparisonModal.tsx';

const rootElement = document.getElementById('REACT_comparison_modal');

if (rootElement) {
  let root = createRoot(rootElement);
  root.render(
    <ComparisonModal />
  );
}
